<div class="check-list" [class.is-disabled]="disabled">
  <div class="check-list-toolbar">
    <label class="check-list-search">
      <mat-icon aria-hidden="true">search</mat-icon>
      <input type="search"
        [value]="search"
        [placeholder]="searchPlaceholder"
        [attr.aria-label]="(ariaLabel || 'List') + ' search'"
        [disabled]="items.length === 0"
        (input)="onSearch($event)">
    </label>
    <span class="check-list-count" [class.has-selection]="selectedCount > 0">{{ selectedCount }}/{{ items.length }}</span>
  </div>

  <div class="check-list-actions">
    <button type="button" class="check-list-action"
      matTooltip="Show only selected values"
      [class.is-active]="onlySelected"
      [attr.aria-pressed]="onlySelected"
      [disabled]="items.length === 0"
      (click)="toggleOnlySelected()">
      <mat-icon aria-hidden="true">filter_list</mat-icon> Selected
    </button>
    <span class="check-list-actions-spacer"></span>
    <button type="button" class="check-list-action"
      matTooltip="Select all visible values"
      [disabled]="disabled || visibleItems.length === 0"
      (click)="selectVisible()">
      <mat-icon aria-hidden="true">done_all</mat-icon> All
    </button>
    <button type="button" class="check-list-action"
      matTooltip="Clear all visible values"
      [disabled]="disabled || selectedCount === 0"
      (click)="clearVisible()">
      <mat-icon aria-hidden="true">remove_done</mat-icon> None
    </button>
  </div>

  <ul class="check-list-items" [attr.aria-label]="ariaLabel || null">
    @for (item of visibleItems; track item[bindValue]) {
      <li>
        <label class="check-list-item" [class.is-selected]="isSelected(item)" [title]="item[bindLabel]">
          <input type="checkbox" [checked]="isSelected(item)" [disabled]="disabled" (change)="toggle(item)">
          <span class="check-list-label">{{ item[bindLabel] }}</span>
        </label>
      </li>
    } @empty {
      <li class="check-list-empty">{{ items.length && (search || onlySelected) ? 'No matching values' : emptyText }}</li>
    }
  </ul>
</div>
